<template>
  <div style="width: 50%;margin: 100px auto;">
		<el-form :model="ruleForm" :rules="rules" v-loading="loading" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="提现订单号" prop="order_id" >
				<el-input v-model="ruleForm.order_id" placeholder="提现订单号" size="medium" clearable style="width: 500px"></el-input>
			</el-form-item>
			<el-form-item style="text-align: center;margin-left: 150px" >
				<el-button type="primary" @click="submitForm('ruleForm')"  size="medium">确定</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
  name: "refundTreatment",
	data() {
		return {
			loading: false,
			ruleForm: {
				order_id: ''
			},
			rules: {
				order_id: [
					{ required: true, message: '请输入提现订单号', trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$api.post("/api/system/payBankBack", this.ruleForm, res => {
						if (res.status == 200) {
							this.$message.success(res.msg);
						} else {
							this.$message.error(res.msg);
						}
						//渲染结束后取消加载
						this.loading = false;
					})
				} else {
					return false;
				}
			});
		}
	}
}
</script>

<style scoped>
</style>